import type { FlashSameRoomSelection, OfferPageMultiRoomMode, OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { getBasePackageUniqueKey } from 'lib/offer/offerUtils'

type SelectablePackage = Pick<App.HotelPackage, 'uniqueKey' | 'cancellationOptionPolicy'>

export function getFlashSameRoomSelection(offerId: string, pkg: SelectablePackage): FlashSameRoomSelection {
  return { offerId, packageKey: getBasePackageUniqueKey(pkg) }
}

export function isFlashSameRoomSelectionOf(selection: FlashSameRoomSelection | undefined, offerId: string, pkg: SelectablePackage): boolean {
  return selection?.offerId === offerId && selection.packageKey === getBasePackageUniqueKey(pkg)
}

function homogeneousExplicitRoom(rooms: Array<OfferPageRoom>, mode?: OfferPageMultiRoomMode): OfferPageRoom | undefined {
  if (rooms.length > 1 && mode !== 'same-room') return undefined
  const first = rooms[0]
  if (!first?.roomId || !first.rateId) return undefined
  const extras = [...first.optionalBundleIds ?? []].sort().join('|')
  return rooms.every(room => room.roomId === first.roomId && room.rateId === first.rateId && [...room.optionalBundleIds ?? []].sort().join('|') === extras) ? first : undefined
}

export function getInitialFlashSameRoomSelection(offer: Pick<App.HotelOffer, 'id' | 'packages'>, rooms: Array<OfferPageRoom>, duration?: number, mode?: OfferPageMultiRoomMode): FlashSameRoomSelection | undefined {
  const first = homogeneousExplicitRoom(rooms, mode)
  if (!first) return undefined
  const candidates = offer.packages.filter(pkg => (pkg.id === first.roomId || pkg.roomType?.id === first.roomId) && pkg.roomRate.id === first.rateId && pkg.duration === duration)
  const packageKeys = new Set(candidates.map(getBasePackageUniqueKey))
  return packageKeys.size === 1 ? { offerId: offer.id, packageKey: [...packageKeys][0] } : undefined
}
